import React, { FC } from 'react'
import { FormattedDateTime } from 'transfix-ui/components/FormattedDateTime'
import { FormattedDateTimeRange } from 'transfix-ui/components/FormattedDateTimeRange'
import { Box, Grid, Typography } from 'transfix-ui/core'
import { useBreakpointContext } from 'utils/context/BreakpointContext'
import { IStop } from 'apps/fleet-planner/types'
import { capitalize } from 'utils/capitalize'
import { AllowedTimezones, currentTimezone } from 'constants/AllowedTimezones'
import { StopsDivider } from './StopsDivider'

interface IDashboardListRowLocation {
  stops: Partial<IStop>[]
}

export const DashboardListRowLocation: FC<IDashboardListRowLocation> = ({ stops = [] }) => {
  const [firstStop] = stops || []
  const lastStop = stops[stops.length - 1]
  const {
    city: fsCity,
    displayTimezone: fsDisplayTimezone,
    endAt: fsEndAt,
    startAt: fsStartAt,
    stateCode: fsStateCode,
  } = firstStop || {}
  const {
    city: lsCity,
    displayTimezone: lsDisplayTimezone,
    endAt: lsEndAt,
    startAt: lsStartAt,
    stateCode: lsStateCode,
  } = lastStop || {}

  const { isMobile } = useBreakpointContext()

  // if the stop has both a startAt and an endAt, it is an appointment window
  const isFirstStopWindow = fsStartAt && fsEndAt
  const isLastStopWindow = lsStartAt && lsEndAt

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={5}>
        <Typography variant='button' component='div'>
          {capitalize(fsCity)}, {fsStateCode}
        </Typography>
        <Typography variant='body2' component='div'>
          {isFirstStopWindow ? (
            <FormattedDateTimeRange
              startAt={fsStartAt || ''}
              endAt={fsEndAt || ''}
              startAtTimezone={(fsDisplayTimezone as AllowedTimezones) || currentTimezone}
              endAtTimezone={(fsDisplayTimezone as AllowedTimezones) || currentTimezone}
              format='dateAndYear'
              timeShort
              showTimezone
            />
          ) : (
            <FormattedDateTime
              datetime={fsStartAt || '0'}
              displayTimezone={(fsDisplayTimezone as AllowedTimezones) || currentTimezone}
              format='timeWeekdayDateAndYear'
              timeShort
              showTimezone
            />
          )}
        </Typography>
      </Grid>
      {!isMobile && (
        <Grid item xs={12} md={2}>
          <Box display='flex' justifyContent='flex-end' alignContent='center'>
            <StopsDivider stops={stops as IStop[]} />
          </Box>
        </Grid>
      )}
      <Grid item md={5} xs={12}>
        <Typography variant='button' component='div'>
          {capitalize(lsCity)}, {lsStateCode}
        </Typography>
        <Typography variant='body2' component='div'>
          {isLastStopWindow ? (
            <FormattedDateTimeRange
              startAt={lsStartAt || ''}
              endAt={lsEndAt || ''}
              startAtTimezone={(lsDisplayTimezone as AllowedTimezones) || currentTimezone}
              endAtTimezone={(lsDisplayTimezone as AllowedTimezones) || currentTimezone}
              format='dateAndYear'
              timeShort
              showTimezone
            />
          ) : (
            <FormattedDateTime
              datetime={lsStartAt || '0'}
              displayTimezone={(lsDisplayTimezone as AllowedTimezones) || currentTimezone}
              format='timeWeekdayDateAndYear'
              timeShort
              showTimezone
            />
          )}
        </Typography>
      </Grid>
    </Grid>
  )
}
